// extracted by mini-css-extract-plugin
export default {"fiexed":"fiexed_fiexed__McpaM","messenger":"fiexed_messenger__0pgHt","domContext":"fiexed_domContext__WtTB5","Txt":"fiexed_Txt__CfgXX"};